import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { SharedService } from 'src/app/_shared/shared.service';
import { RepService, parseValidationErrors } from '../../services/rep.service';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {
  data = {
    fullname: '',
    email: '',
    username: '',
    password: '',
    passwordConfirm: '',
    company_name: '',
    ico: ''
  };
  isLoading = false;
  registrationSuccess = false;
  errorMessage = '';
  passwordMismatch = false;

  constructor(
    private repService: RepService,
    private router: Router,
    private notifications: NotificationsService,
    private shared: SharedService
  ) { }

  ngOnInit(): void { }

  onPasswordChange(): void {
    this.passwordMismatch = !!this.data.passwordConfirm && this.data.password !== this.data.passwordConfirm;
  }

  async onSubmit(): Promise<void> {
    this.onPasswordChange();
    if (this.passwordMismatch) return;

    this.isLoading = true;
    this.errorMessage = '';

    try {
      const result = await this.repService.register({
        username: this.data.username,
        email: this.data.email,
        password: this.data.password,
        fullname: this.data.fullname,
        company_name: this.data.company_name,
        ico: this.data.ico || null
      });

      if (result?.success) {
        this.registrationSuccess = true;
        this.notifications.success('Registrace', result.message || 'Registrace byla úspěšná');
      } else {
        this.errorMessage = result?.message || 'Registrace se nezdařila';
        this.notifications.error('Chyba', this.errorMessage);
      }
    } catch (error: any) {
      this.shared.reportError(error, 'Registration error');

      if (error?.status === 422) {
        this.errorMessage = parseValidationErrors(error);
      } else if (error?.error?.message) {
        this.errorMessage = error.error.message;
      } else if (error?.message) {
        this.errorMessage = error.message;
      } else {
        this.errorMessage = 'Registrace se nezdařila. Zkuste to prosím později.';
      }

      this.notifications.error('Chyba', this.errorMessage);
    } finally {
      this.isLoading = false;
    }
  }

  goToLogin(): void {
    this.router.navigate(['/login']);
  }
}
